export default "/images/vendor/flag-icon-css/flags/4x3/tm.svg?a9bdcd11c19fd20e90b890cb16adb247";